import { ca } from '@cian/analytics';

import { IExpertOfferSuggestionsSchema } from 'shared/repositories/cian-chat-bot/entities/expert_opinion_offer/ExpertOfferSuggestionsSchema';

interface ITrackShowExpertOptionParams {
  offerId: number;
  suggestions: IExpertOfferSuggestionsSchema[];
}

export function trackShowExpertOption({ offerId, suggestions }: ITrackShowExpertOptionParams) {
  const displayTexts = suggestions.map(suggestion => suggestion.displayText);

  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Show_sopr',
    label: 'Expert',
    page: {
      extra: {
        text: displayTexts,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
}

export function trackClickExpertOptionButton(offerId: number, text: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Expert',
    page: {
      extra: {
        text,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
}

export function trackSendExpertOptionInput(offerId: number, text: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Send_sopr',
    label: 'Write',
    page: {
      extra: {
        text,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
}

export function trackClickExpertOptionInput(offerId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Write',
    products: [
      {
        id: offerId,
        offerType: 'offer',
      },
    ],
  });
}
